import PropTypes from 'prop-types'
import React from 'react'
import {connect} from 'react-redux'
import {createStructuredSelector} from 'reselect'

import * as pdp from '../../store/productDetailPage'
import Head from '../Page/Head'

const ProductHelmet = ({
  isProductRetired,
  name,
  productDescription,
  productImage,
  seoDescription,
  ...props
}) => {
  const description = seoDescription || productDescription
  const productImageUrl = `${productImage}?width=1024`

  return (
    <Head
      description={description}
      image={{type: 'image/jpeg', url: productImageUrl}}
      nonIndexableAndNoFollow={isProductRetired}
      og={{
        description,
        image: {
          url: productImageUrl,
          urlSecure: productImageUrl,
          type: 'image/jpeg',
          width: 1024,
          height: 1060,
        },
        title: name,
        type: 'website',
      }}
      title={name}
      twitter={{
        card: 'summary_large_image',
        description,
        image: productImageUrl,
        title: name,
      }}
      {...props}
    />
  )
}

ProductHelmet.propTypes = {
  isProductRetired: PropTypes.bool.isRequired,
  name: PropTypes.string.isRequired,
  productDescription: PropTypes.string.isRequired,
  productImage: PropTypes.string.isRequired,
  seoDescription: PropTypes.string,
}

const mapStateToProps = createStructuredSelector({
  isProductRetired: pdp.productIsRetired,
  name: pdp.productName,
  productDescription: pdp.productDescription,
  productImage: pdp.productDefaultImage,
  seoDescription: pdp.productSeoDescription,
})

export default connect(mapStateToProps)(ProductHelmet)
